module.exports = __webpack_public_path__ + "img/新月已過.e2112940.svg";